import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/kit";

export default function AdminAssets() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/asset-settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-muted-foreground">Carregando…</div>;
  const setCat = (k, field, v) => setS({ ...s, categories: { ...s.categories, [k]: { ...s.categories[k], [field]: v } } });
  const toggleSym = (sym) => setS({ ...s, disabled_symbols: s.disabled_symbols.includes(sym) ? s.disabled_symbols.filter((x) => x !== sym) : [...s.disabled_symbols, sym] });
  const save = async () => {
    try { await api.put("/admin/asset-settings", { categories: s.categories, disabled_symbols: s.disabled_symbols }); toast.success("Configurações salvas"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-assets-page">
      <PageHeader eyebrow="Configuração" title="Categorias e ativos" desc="Defina quais categorias aparecem em Mercados e quais permitem negociação."
        actions={<Button className="h-11" onClick={save} data-testid="save-asset-settings">Salvar alterações</Button>} />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {Object.entries(s.labels).map(([k, label]) => (
          <div key={k} className="surface p-5 md:p-6" data-testid={`asset-category-${k}`}>
            <div className="font-display text-lg font-semibold">{label}</div>
            <div className="mt-4 space-y-3 text-sm">
              <div className="flex justify-between"><span>Visível em Mercados</span><Switch checked={s.categories[k]?.enabled} onCheckedChange={(v) => setCat(k, "enabled", v)} data-testid={`cat-enabled-${k}`} /></div>
              <div className="flex justify-between"><span>Negociação habilitada</span><Switch checked={s.categories[k]?.trading} onCheckedChange={(v) => setCat(k, "trading", v)} data-testid={`cat-trading-${k}`} /></div>
            </div>
            <div className="eyebrow mt-5 mb-2">Ativos</div>
            <div className="grid grid-cols-2 gap-2 text-sm">
              {s.assets.filter((a) => a.category === k).map((a) => (
                <label key={a.symbol} className="flex items-center gap-2 cursor-pointer">
                  <Checkbox checked={!s.disabled_symbols.includes(a.symbol)} onCheckedChange={() => toggleSym(a.symbol)} data-testid={`asset-toggle-${a.symbol}`} />{a.name}
                </label>))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
